export default __webpack_public_path__ + "static/media/banner-2.4175f9da.png";